import React, { Component } from 'react';

import './AdvisorProfile.scss';

class AdvisorProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      Advisor: Object.assign({}, {
        first_name: '',
        last_name: '',
        photo: null,
        job_positions: [],
        degrees: [],
      }, props.advisorData),
    };
  }

  getImage(imgSrc) {
    if (!imgSrc) {
      return null;
    }

    return (
      <div className="AdvisorProfile-image">
        <div>
          <img src={imgSrc} alt="" />
        </div>
      </div>
    );
  }

  getWork(work, idx) {
    return (
      <div key={idx}>
        <div className="AdvisorProfile-Work-title">{work.title}</div>
        <div className="AdvisorProfile-Work-company">{work.company.name}</div>
      </div>
    );
  }

  getWorkHistory() {
    const { job_positions } = this.state.Advisor;

    const cappedWork = job_positions.slice(0, 3);

    return (
      <div className="AdvisorProfile-Work">{cappedWork.map(this.getWork)}</div>
    );
  }

  getEducation(education, idx) {
    return (
      <div key={idx}>
        <div className="AdvisorProfile-Education-school">
          {education.university.name}
        </div>
        <div className="AdvisorProfile-Education-degree">{education.major.name}</div>
      </div>
    );
  }

  getEducationHistory() {
    const { degrees } = this.state.Advisor;
    return (
      <div className="AdvisorProfile-Education">
        {degrees.map(this.getEducation)}
      </div>
    );
  }

  getBiography(biography = '') {
    if (biography !== null) {
      return biography
        .replace(/[\r|↵]/g, '\n')
        .split('\n')
        .map((item, key) => {
          return <p key={key}>{item}</p>;
        });
    }

    return '';
  }

  getDetails() {
    const { biography, degrees } = this.state.Advisor;

    return (
      <div className="container AdvisorProfile-details">
        <div className="row">
          <div className="col-12 col-sm-7">
            <div className="AdvisorProfile-heading">About Me</div>
            <div className="AdvisorProfile-line" />
            <div>{this.getBiography(biography)}</div>
          </div>
          <div className="col-12 col-sm-5">
            <div className="AdvisorProfile-heading">Work Experience</div>
            <div className="AdvisorProfile-line" />
            {this.getWorkHistory()}
            <br />
            <br />
            {(degrees.length > 0) ? (
              <div>
                <div className="AdvisorProfile-heading">Education</div>
                <div className="AdvisorProfile-line" />
                {this.getEducationHistory()}
              </div>
            ) : null}
          </div>
        </div>
      </div>
    );
  }

  getHeader() {
    const {
      first_name,
      last_name,
      photo,
      job_positions,
      degrees,
    } = this.state.Advisor;

    const imgSrc = photo
      ? '//paragonone-paragon-photo-management-photo-cache-prod.paragonone.com/300x300/' +
      photo
      : null;

    const currentWork = job_positions[0];
    const currentEducation = degrees[0];

    console.log(currentEducation);

    if (this.props.advisorData !== null) {
      return (
        <div className="AdvisorProfile-header">
          <div className="container">
            {this.getImage(imgSrc)}
            <div className="AdvisorProfile-name">
              {first_name} {last_name}
            </div>
            {(typeof currentWork === 'undefined') ? null : (
              <div className="AdvisorProfile-current-title">
                {currentWork && currentWork.title} at {currentWork.company && currentWork.company.name}
              </div>
            )}
            <div className="AdvisorProfile-current-school">
              {currentEducation && currentEducation.university.name}
            </div>
          </div>
        </div>
      );
    }
  }


  render() {
    return (
      <div>
        {this.getHeader()}
        {this.getDetails()}
      </div>
    );
  }
}

export default AdvisorProfile;



// WEBPACK FOOTER //
// ./src/routes/progress-report/routes/ProgressReport/components/ProgressReport/components/AdvisorProfile/index.js